import { useSelector } from 'react-redux';

import { doesCustomerExist } from '../../../common/helpers/customerHelper';

export const useIsActiveLoyalty = () => {
  const settings = useSelector((state) => state.setting.data);

  const { hasLoyalty, status } = settings.loyalty;

  if (!doesCustomerExist()) return false;

  return hasLoyalty && status === 'Active';
};

export const useDoesCartHaveLoyaltyTender = () => {
  const cart = useSelector((state) => state.cart.data);
  let hasLoyaltyTender = false;
  cart.tenders.forEach((tender) => {
    if (tender.tenderType === 'Loyalty Points') {
      hasLoyaltyTender = true;
    }
  });
  return hasLoyaltyTender;
};
